module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/components-title.json
// module id = 1044
// module chunks = 167148900729920